import React, { useState } from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Upload,
  Button,
  Input,
} from "antd";

import {
  PlusCircleFilled,
  DeleteOutlined,
} from "@ant-design/icons";

const { Title } = Typography;

const AudioSection = ({
  selectedAssets = [],
  addFile,
  removeFile,
  setSelectedAssets,
  handleAddAsset,
  handleRemoveAsset,
}) => {

  const [newSoundscapeName, setNewSoundscapeName] = useState("");
  const [newMusicName, setNewMusicName] = useState("");
  const [newSfxName, setNewSfxName] = useState("");

  const effectiveAssets = selectedAssets;

  //--------------------------------------------------
  // Rename group
  //--------------------------------------------------

  const handleGroupNameChange = (assetIndex, value) => {
    setSelectedAssets(prev => {
      const updated = [...prev];
      updated[assetIndex].name = value;
      return updated;
    });
  };

  //--------------------------------------------------
  // Rename file
  //--------------------------------------------------

  const handleAudioNameChange = (
    assetIndex,
    audioIndex,
    value
  ) => {
    setSelectedAssets(prev => {
      const updated = [...prev];
      updated[assetIndex].data[audioIndex].name = value;
      return updated;
    });
  };

  //--------------------------------------------------
  // Render one asset type
  //--------------------------------------------------

  const renderAudioGroups = (
    type,
    title,
    newName,
    setNewName
  ) => (
    <>
      <Title level={4}>{title}</Title>

      <Input
        placeholder={`${title} Gruppenname`}
        value={newName}
        onChange={(e) =>
          setNewName(e.target.value)
        }
        style={{
          marginBottom: 10,
          maxWidth: 350,
        }}
      />

      <Button
        type="primary"
        icon={<PlusCircleFilled />}
        disabled={!newName.trim()}
        onClick={() => {
          handleAddAsset(type, newName.trim(), null);
          setNewName("");
        }}
        style={{ marginBottom: 20 }}
      >
        Neue {title}-Gruppe
      </Button>

      {effectiveAssets
        .map((asset, assetIndex) =>
          asset.type === type ? (
            <Card
              key={`${type}-${assetIndex}`}
              style={{ marginBottom: 20 }}
            >
              <Row gutter={[16, 16]}>
                <Col span={24}>

                  <Input
                    value={asset.name}
                    onChange={(e) =>
                      handleGroupNameChange(
                        assetIndex,
                        e.target.value
                      )
                    }
                    style={{
                      marginBottom: 16,
                    }}
                  />

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                    }}
                  >
                    {(asset.data || []).map(
                      (audio, audioIndex) => (
                        <Card
                          key={audioIndex}
                          size="small"
                        >
                          <audio
                            controls
                            src={audio.url}
                            style={{
                              width: "100%",
                              marginBottom: 8,
                            }}
                          />

                          <Input
                            value={audio.name}
                            onChange={(e) =>
                              handleAudioNameChange(
                                assetIndex,
                                audioIndex,
                                e.target.value
                              )
                            }
                          />

                          <Button
                            danger
                            icon={
                              <DeleteOutlined />
                            }
                            style={{
                              marginTop: 8,
                            }}
                            onClick={() =>
                              removeFile(
                                assetIndex,
                                audioIndex
                              )
                            }
                          >
                            Datei entfernen
                          </Button>
                        </Card>
                      )
                    )}
                  </div>

                  <Upload
                    accept="audio/*"
                    multiple
                    showUploadList={false}
                    beforeUpload={(file) => {
                      addFile(file, assetIndex);
                      return false;
                    }}
                  >
                    <Button
                      icon={
                        <PlusCircleFilled />
                      }
                      style={{
                        marginTop: 16,
                      }}
                    >
                      Audiodateien hinzufügen
                    </Button>
                  </Upload>

                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    style={{
                      marginTop: 16,
                      marginLeft: 12,
                    }}
                    onClick={() =>
                      handleRemoveAsset(assetIndex)
                    }
                  >
                    Gruppe entfernen
                  </Button>

                </Col>
              </Row>
            </Card>
          ) : null
        )}
    </>
  );

  //--------------------------------------------------

  return (
    <Card
      className="editorContainer"
      bordered
    >

      {renderAudioGroups(
        3,
        "Soundscapes",
        newSoundscapeName,
        setNewSoundscapeName
      )}

      {renderAudioGroups(
        4,
        "Music",
        newMusicName,
        setNewMusicName
      )}

      {renderAudioGroups(
        5,
        "Sound Effects",
        newSfxName,
        setNewSfxName
      )}

    </Card>
  );
};

export default AudioSection;